import React from 'react';
import {
  createStyles,
  withStyles,
  Tooltip,
  TooltipProps,
  Box,
} from '@material-ui/core';

const FsTooltip = withStyles(({ palette, spacing, breakpoints }) =>
  createStyles({
    arrow: {
      color: palette.common.white,
    },
    tooltip: {
      maxWidth: 310,
      padding: spacing(2),
      fontSize: 14,
      fontWeight: 400,
      color: palette.common.black,
      backgroundColor: palette.common.white,
      boxShadow: `0px 6px 12px rgba(9, 9, 10, 0.02), 0px 12px 48px rgba(27, 29, 31, 0.06)`,
      [breakpoints.up('sm')]: {
        maxWidth: 336,
      },
    },
  })
)(({ children, ...otherProps }: TooltipProps) => {
  return (
    <Tooltip {...otherProps} placement="top" arrow>
      <Box>{children}</Box>
    </Tooltip>
  );
});

export default FsTooltip;
